import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type CadastrarAndamentoCompatibilidadePayload = {
  descricao: string;
  observacoes: string;
  visibilidade?: "ADM" | "INTERNO" | "PUBLICO";
  criadoPorTipo?: "SISTEMA" | "ADM" | "INTERNO" | "USUARIO" | "LEAD";
  criadoPorId?: number | null;
  metadata?: Record<string, any>;
};

export const cadastrarAndamentoCompatibilidadeService = async (
  compatibilidadeId: number,
  data: CadastrarAndamentoCompatibilidadePayload
) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/compatibilidades/${compatibilidadeId}/andamentos`;

    try {
      const response = await axios.post(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return false;
};
